export enum IhiStatusType
{
  None = "None",
  Active = "Active",
  Deceased = "Deceased",
  Expired = "Expired",
  Resolved = "Resolved",
  Retired = "Retired"
}